export const MODAL_TYPE_PIN_POST = 'pin-post';
